import { required, Text, numberValidation, amountValidation, ColorOptions } from '@jfs/ui-new'
import { TextInputNew as TextInput } from '../../components/AdminInputs'
import { Dropdown } from '../../components/Dropdown'
import { WrapperText } from '../../components/WrapperText'

const textinputStyle = {
  type: 'body14',
  borderColor: '#d1d3e2' as ColorOptions,
  labelPaddingBottom: 8,
  borderRadius: 4,
  labelFontFamily: 'jiotype-bold',
  fontFamily: 'jiotype-medium',
  labelColor: '#6e707e' as ColorOptions,
  labelFontSize: 12,
  fontSize: 14,
  selectionColor: 'BLUE',
  paddingHorizontal: 8,
  color: '#6e707e' as ColorOptions,
  paddingVertical: 8,
  focusBorderColor: '#d1d3e2' as ColorOptions,
  borderWidth: 2,
  onFocusBorderWidth: 2,
}

export const formData = (props: any) => [
  {
    formItems: [
      {
        fieldName: 'ruleName',
        ComponentName: TextInput,
        ...textinputStyle,
        label: 'Rule Name',
        placeholder: 'Rule Name',
        validationSchema: required,
      },
      {
        fieldName: 'payeeType',
        ComponentName: TextInput,
        ...textinputStyle,
        label: 'Payee Type',
        placeholder: 'Payee Type',
        validationSchema: numberValidation,
      },
      {
        fieldName: 'payeeUserId',
        ComponentName: TextInput,
        ...textinputStyle,
        label: 'Payee user Id',
        placeholder: 'Payee user Id',
        validationSchema: required,
      },
      {
        fieldName: 'payeeVpa',
        ComponentName: TextInput,
        ...textinputStyle,
        label: 'Payee VPA',
        placeholder: 'Payee VPA',
        validationSchema: required,
      },
      {
        fieldName: 'payerBankId',
        ComponentName: Dropdown,
        title: 'Payer Bank ID',
        validationSchema: required,
        data: props.payerbankIds,
      },
      {
        fieldName: 'binList',
        ComponentName: TextInput,
        ...textinputStyle,
        label: 'Bin List',
        placeholder: 'Bin List',
        validationSchema: required,
      },
      {
        fieldName: 'binListPropmpt',
        ComponentName: Text,
        title: '(Enter comma(,) separated values for Bin List)',
        type: 'h4',
        color: 'BLACK',
      },
      {
        fieldName: 'binRange',
        ComponentName: Text,
        title: 'Bin Range',
        type: 'h4Bold',
        color: 'LIGHT_BLACK',
      },
      {
        fieldName: 'binFrom',
        ComponentName: TextInput,
        ...textinputStyle,
        label: 'From',
        placeholder: 'From',
        validationSchema: required,
      },
      {
        fieldName: 'binTo',
        ComponentName: TextInput,
        ...textinputStyle,
        label: 'TO',
        placeholder: 'To',
        validationSchema: required,
      },
      {
        fieldName: 'cardType',
        ComponentName: Dropdown,
        title: 'Card Type',
        validationSchema: required,
        data: props.cardType,
      },
      {
        fieldName: 'scheme',
        ComponentName: Dropdown,
        title: 'Scheme',
        validationSchema: required,
        data: props.schema,
      },
      {
        fieldName: 'amountRange',
        ComponentName: Text,
        title: 'Amount Range',
        type: 'h4Bold',
        color: 'LIGHT_BLACK',
        // validationSchema: required,
      },
      {
        fieldName: 'minAmount',
        ComponentName: TextInput,
        ...textinputStyle,
        label: 'Min Amount',
        placeholder: 'Min Amount',
        validationSchema: amountValidation,
      },
      {
        fieldName: 'maxAmount',
        ComponentName: TextInput,
        ...textinputStyle,
        label: 'Max Amount',
        placeholder: 'Max Amount',
        validationSchema: amountValidation,
      },
      {
        fieldName: 'transactionInitiatingEntityId',
        ComponentName: Dropdown,
        title: 'Entity Id',
        validationSchema: required,
        data: props.entityID,
      },
      {
        fieldName: 'transactionApplication',
        ComponentName: TextInput,
        ...textinputStyle,
        label: 'Transaction Application',
        placeholder: 'Transaction Application',
        validationSchema: required,
      },
      {
        fieldName: 'txntype',
        ComponentName: Dropdown,
        title: 'Transaction Type',
        validationSchema: required,
        data: props.txnType,
      },
      {
        fieldName: 'instrumentType',
        ComponentName: Dropdown,
        title: 'Transaction sub Type',
        validationSchema: required,
        data: props.instrumentType,
      },
      {
        fieldName: 'mode',
        ComponentName: TextInput,
        ...textinputStyle,
        label: 'Transaction Mode',
        placeholder: 'Transaction Mode',
        validationSchema: numberValidation,
      },
      {
        fieldName: 'activationGroup',
        ComponentName: TextInput,
        ...textinputStyle,
        label: 'Activation Group',
        placeholder: 'Activation Group',
        validationSchema: required,
      },
      {
        fieldName: 'priority',
        ComponentName: TextInput,
        ...textinputStyle,
        label: 'Priority',
        placeholder: 'Priority',
        validationSchema: numberValidation,
      },
      {
        fieldName: 'processor',
        ComponentName: TextInput,
        ...textinputStyle,
        label: 'Processor',
        placeholder: 'Processor',
        editable: false,
        value: props.processor,
      },
      {
        fieldName: 'isActive',
        ComponentName: Dropdown,
        title: 'Status',
        validationSchema: required,
        data: [{ value: 'Enable' }, { value: 'Disable' }],
      },
      {
        fieldName: 'message',
        ComponentName: WrapperText,
        title: props?.message,
        color: 'ERROR',
        hide: props?.message === '',
      },
    ],
    onSubmit: async (values: any) => {
      if (props?.id) {
        props?.updateRule({ ...values, isAssigned: props?.isAssigned ?? 'N' })
      } else {
        props?.addRule(values)
      }
      return 'endPointDetails'
    },
    actionTitle: 'Add Rule',
  },
]
